/**
 * Editorial guidebook lists. The same kinds exist in every city.
 * A city has at most one list of each kind. The public slug never
 * contains a city name.
 */
export enum CityCollectionKindEnum {
    MUST_SEE = 'must_see',
    FIRST_VISIT = 'first_visit',
    ONE_DAY = 'one_day',
    WITH_KIDS = 'with_kids',
    FOR_COUPLES = 'for_couples',
    UNUSUAL = 'unusual',
    PHOTOGENIC = 'photogenic',
    VIEWPOINTS = 'viewpoints',
    FREE = 'free',
    RAINY_DAY = 'rainy_day',
    EVENING = 'evening',
    SUNSET = 'sunset',
    HIDDEN_GEMS = 'hidden_gems',
    LOCAL = 'local',
    MUSEUMS_AND_ART = 'museums_and_art',
    TEMPLES = 'temples',
    WALKS = 'walks',
    ARCHITECTURE = 'architecture',
    HISTORY = 'history',
    AUDIO = 'audio',
    SHORT_VISIT = 'short_visit',
    LONG_VISIT = 'long_visit',
    SHOPPING = 'shopping',
    FOOD = 'food',
}

export const CITY_COLLECTION_KINDS: CityCollectionKindEnum[] = Object.values(CityCollectionKindEnum);

export const collectionKindSlug = (kind: CityCollectionKindEnum): string => kind.replace(/_/g, '-');

export const collectionKindFromSlug = (slug: string): CityCollectionKindEnum | null => {
    const value = slug.trim().toLowerCase().replace(/-/g, '_');

    return (CITY_COLLECTION_KINDS as string[]).includes(value)
        ? (value as CityCollectionKindEnum)
        : null;
};
